import request from './index'
// banner
export function bannerList (data) {
    return request.get('/v1/web/banner', {
        params: data
    })
}
// 园区服务文本
export function parkInfo (data) {
    return request.get(`/v1/web/park/form/${data.type}`, {
        params: data
    })
}
// 新闻列表
export function newList (data) {
    return request.get(`/v1/web/news`, {
        params: data
    })
}
// 首页数据块
export function blockData (data) {
    return request.get(`/v1/web/index/blockData`, {
        params: data
    })
}
// 企业联系我们|关于我们
export function contactUs (data) {
    return request.get(`/v1/web/park/contact`, {
        params: data
    })
}
// 新闻详情
export function newInfo (data) {
    return request.get(`/v1/web/news/${data.id}`, {
        params: data
    })
}
// 政企服务
export function policyList (data) {
    return request.get(`/v1/web/park/policy`, {
        params: data
    })
}
// 政企服务详情
export function policyInfo (data) {
    return request.get(`/v1/web/park/policy/${data.type}`, {
        params: data
    })
}
// 组织架构
export function organization (data) {
    return request.get(`/v1/web/park/organization`, {
        params: data
    })
}
// 大事记
export function history (data) {
    return request.get(`/v1/web/park/history`, {
        params: data
    })
}
// 人才招聘
export function recruitment (data) {
    return request.get(`/v1/web/recruitment`, {
        params: data
    })
}
// 招商项目查询
export function project (data) {
    return request.get(`/v1/web/attract-investment/project`, {
        params: data
    })
}
// 企业风采
export function starEnterprise (data) {
    return request.get(`/v1/web/enterprise/star`, {
        params: data
    })
}
// 企业列表
export function enterpriseList (data) {
    return request.get(`/v1/web/enterprise`, {
        params: data
    })
}
// 企业详情
export function enterpriseInfo (data) {
    return request.get(`/v1/web/enterprise/${data.id}`, {
        params: data
    })
}
// 招商项目详情
export function projectInfo (data) {
    return request.get(`/v1/web/attract-investment/project/${data.id}`, {
        params: data
    })
}
// 联系我们 - 子站
export function enterContact (data) {
    return request.get(`/v1/web/enterprise/contact/${data.enterpriseId}`, {
        params: data
    })
}
// 产品类别
export function proType (data) {
    return request.get(`/v1/web/enterprise/product/${data.enterpriseId}/type`, {
        params: data
    })
}
// 产品列表
export function proList (data) {
    return request.get(`/v1/web/enterprise/product/${data.enterpriseId}/product`, {
        params: data
    })
}

// 产品详情
export function proInfo (data) {
    return request.get(`/v1/web/enterprise/product/${data.enterpriseId}/${data.id}`, {
        params: data
    })
}
// 荣誉墙
export function honorWall (data) {
    return request.get(`/v1/web/index/honor-wall`, {
        params: data
    })
}


export default {

}


// WEBPACK FOOTER //
// ./src/api/api.js